// extracted by mini-css-extract-plugin
export default {"skeleton":"skeleton--JUUSn","pulse":"pulse--1tjCe","skeleton--circle":"skeleton--circle--3ejSx","skeleton--block":"skeleton--block--ykFMr"};
    if(module.hot) {
      // 1747648148381
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  